import "./login.less";
import React, { useEffect, useState } from "react";
import axios_init from "@/utils/axios_init";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Form, Input, Button } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { isLoadingOverlay, setAuthTokens, changeLoader } from "@/redux/actions";
import { setUserPermissions } from "../../redux/actions/authActions";
import logoImg from "@/assets/images/login_right_image.png";
import ReCAPTCHA from "react-google-recaptcha";
function Login() {
  // const token = localStorage.getItem("token");
  const [token, setToken] = useState(localStorage.getItem("token") || '');
  const dispatch = useDispatch();
  const history = useHistory();
  const [notfound, setNotFound] = useState(false);
  const [username, setUsername] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [vis, setVis] = useState(false);
  const [ tooManyAtt , setTooManyAttempts] = useState(false);
  const roleID = localStorage.getItem("role_id");
  const [responseData, setResponseData] = useState(null);
  const [captcha, setCaptcha ] = useState('')
  useEffect(() => {
    dispatch(isLoadingOverlay(false));
  }, []);

  // Get permissions for the user
  const getPermissions = () => {
    axios_init
      .get(`auth/role/${roleID}`)
      .then(({ data }) => {
        localStorage.setItem("sys_user_type", data?.name);
        dispatch(setUserPermissions(data.permissions));
      })
      .catch((err) => {});
  };
  // useEffect(() => {
  //   if (token) {
  //     console.log('token', token)
  //     getPermissions();
  //   }
  // }, [token]);

  // const [loginSuperAdmin, loginInfo] = useMutation(requests.auth.login, {
  //   onSuccess: (res) => {
  //     dispatch(isLoadingOverlay(false));
  //     dispatch(setAuthTokens(res.data.token.access_token));
  //     localStorage.setItem("token", res.data.token.access_token);
  //     localStorage.setItem(
  //       "user-data",
  //       JSON.stringify({ name: username, type: "SUPER-ADMIN" })
  //     );
  //     history.push("/");
  //   },
  //   onError: (e) => {
  //     setNotFound(true);
  //     dispatch(isLoadingOverlay(false));
  //     setVis(false);
  //   },
  // });

  const login = async (values) => {

    try {
      let { data } = await axios_init.post("/auth/login", 
      {
        username: values.username,
        password: values.password,
      }
    );
    setOtpSent(true);
    console.log('data', data);
    setResponseData(data);
    dispatch(isLoadingOverlay(false));

    } catch (e) {
      if (e.response.status == 698) { // 698 - это ошибка, связанная с капчей (talked with backend dev.)
        setCaptcha('true')
      }
      if (e.response.status == 429) {
        // 429 - это ошибка, связанная с капчей (talked with backend dev.)
        setTooManyAttempts(true)
      }
      setNotFound(true);
      setVis(false);
      dispatch(isLoadingOverlay(false));
      return;
    }
    

    // try {
    //   let { data } = await axios_init(
    //     "/auth/one2many/login",
    //     { ...values, data: "" }
    //   );
    //   let oneMinuteToken = data.token.access_token;

    //   try {
    //     let { data } = await axios_init.get(
    //       `/branch-user-token/${oneMinuteToken}`
    //     );
    //     let { branch_id, name, image } = data;
    //     localStorage.setItem("role_id", JSON.stringify(data.role_id));
    //     localStorage.setItem("branch_id", JSON.stringify(data.branch_id));

    //     try {
    //       let { data } = await requests.auth.branchLogin({
    //         ...values,
    //         data: branch_id,
    //       });
    //       dispatch(isLoadingOverlay(false));
    //       dispatch(setAuthTokens(data.token.access_token));
    //       localStorage.setItem("token", data.token.access_token);
    //       localStorage.setItem(
    //         "user-data",
    //         JSON.stringify({
    //           branch_id,
    //           name,
    //           image,
    //           type: data.client_type.name,
    //         })
    //       );
    //       history.push("/");
    //       document.location.reload();
    //     } catch (e) {
    //       setNotFound(true);
    //       setVis(false);
    //       dispatch(isLoadingOverlay(false));
    //     }
    //   } catch (e) {
    //     setNotFound(true);
    //     setVis(false);
    //     dispatch(isLoadingOverlay(false));
    //   }
    // } catch (e) {
    //   loginSuperAdmin(values);
    //   setVis(false);
    // }
  };

  const onFinish = (values) => {
    setUsername(values?.username);
    dispatch(isLoadingOverlay(true));
    login(values);
    setVis(true);
  };

  const onCofirmOtp = async (values) => {

    dispatch(isLoadingOverlay(true));
    try {
      const { data } = await axios_init.post("/auth/login/confirm", {
        passcode: values.otp,
        passcode_token: responseData.passcode_token,
      });
      console.log('data>.>>>', data);
      dispatch(setAuthTokens(data.token.access_token));
      localStorage.setItem("token", data.token.access_token);
      setToken(data.token.access_token);
      localStorage.setItem('role_id', JSON.stringify(data.user.role_id))
      localStorage.setItem('branch_id', JSON.stringify(data.branch_id))
      localStorage.setItem("user-data",
            JSON.stringify({
              data: data?.branch_id,
              name: data?.name || 'no name',
              image: data?.user?.image ||  "",
              type: data.client_type?.name,
            })
          );
      dispatch(isLoadingOverlay(false));
      document.location.reload();
      history.push("/");
    } catch (e) {
      dispatch(isLoadingOverlay(false));
      setVis(false);
    }
  }
  const onChange = (value) => {
    console.log("Captcha value:", value);
    setCaptcha(value);
    verifyHuman(value)
  }

  const verifyHuman = async (token) => {
    try {
      const dataInfo = await axios_init.post(`/auth/captcha/confirm?token=${token}&username=${username}`, {})

      console.log('dataInfo', dataInfo)
      setCaptcha('')
    } catch (error) {
      console.log('Err', error)
    }
  }

  if (tooManyAtt) {
    return (
      <div className="login-container">
      <div className="login-left">
      <div className="logo">
            <img width={"70px"} src="/favicon.svg" alt="Delivery Logo" />
          </div>
          <h1>
          Слишком много попыток. <br></br> Попробуйте снова через <span style={{ color: 'red', textDecoration: 'underline'}}>5 минут.</span>
          {" "} <br></br>
            <span className="highlight">Card Delivery</span>
          </h1>

      </div>
      <div
        className="login-right"
        style={{
          backgroundImage: `url(${logoImg})`,
        }}
      ></div>
    </div>
    );
  }
  return (
    <>
      <div className="login-container">
        <div className="login-left">
          <div className="logo">
            <img width={"130px"} src="/favicon.svg" alt="Card Delivery Logo" />
          </div>
          <h1>
            Добро пожаловать в систему{" "}
            <span className="highlight">Card Delivery</span>
          </h1>
          {otpSent ? 
            <p style={{ marginTop: 4 }}>{`Мы отправили код подтверждения на ваш номер +998 ${responseData?.phone} . Пожалуйста, введите OTP, чтобы продолжить.`}</p>
          : <p>Пожалуйста, введите свои данные, чтобы авторизоваться.</p>}
          {!otpSent ? <Form
            style={{ width: "100%" }}
            name="normal_login"
            className="login-form-item"
            initialValues={{ remember: true }}
            onFinish={onFinish}
          >
            {
              !captcha ? <div style={{ width: '320px'}}>
              <Form.Item
                name="username"
                style={{ width: "100%" }}
                rules={[
                  {
                    required: true,
                    message: "Пожалуйста, введите ваше имя пользователя!",
                  },
                ]}
              >
                <Input
                  size="large"
                  style={{ borderRadius: 8 }}
                  width={"100%"}
                  prefix={<UserOutlined className="site-form-item-icon" />}
                  placeholder="Введите логин"
                />
              </Form.Item>
              <Form.Item
                name="password"
                style={{ width: "100%" }}
                rules={[
                  { required: true, message: "Пожалуйста, введите свой пароль!" },
                ]}
              >
                <Input.Password
                  size="large"
                  style={{ borderRadius: 8 }}
                  width={"100%"}
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  placeholder="Введите пароль"
                  autoComplete
                />
              </Form.Item>
              <Form.Item style={{ width: "100%" }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                  size="large"
                  style={{ borderRadius: 8, width: "100%" }}
                >
                  Войти
                </Button>
              </Form.Item>
              </div> : 

              <ReCAPTCHA
              sitekey="6LfFPIMrAAAAACVxtGbZl7hf_iq96TUzV82Jl76l"
              onChange={onChange}
            />
            }
          </Form> : 
          <Form
            style={{ width: "100%" }}
            name="normal_login_3"
            className="login-form-item"
            onFinish={onCofirmOtp}
          >
            <Form.Item
              name="otp"
              style={{ width: "80%" }}
              rules={[
                {
                  required: true,
                  message: "Пожалуйста, введите OTP код!",
                },
              ]}
            >
              <Input
                size="large"
                style={{ borderRadius: 8 }}
                width={"320px"}
                prefix={<UserOutlined className="site-form-item-icon" />}
                placeholder="Введите OTP код"
              />
            </Form.Item>
            <Form.Item style={{ width: "80%" }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', justifyContent: 'center', textAlign: 'center' }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                  size="large"
                  style={{ borderRadius: 8, width: "100%" }}
                >
                  Подтвердить
                </Button>
                <div>Нет смс-кода ? <a onClick={() => setOtpSent(el => !el)}>Отправить повторно</a></div>
              </div>
            </Form.Item>
          </Form>}
        </div>
        <div
          className="login-right"
          style={{
            backgroundImage: `url(${logoImg})`,
          }}
        ></div>
      </div>
    </>
  );
}
export default Login;
